// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","907":"d0c16330"}[chunkId] + "-" + {"230":"cddbabd74bdef3c9eeac","907":"21a8e5b19bedd90a9cb5"}[chunkId] + ".js";
};